import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
  SETTING_CHECKOUT_PAGE_REQUEST,
  SETTING_CHECKOUT_UPDATE_SETTING,
} from 'actions/setting/checkout/constant';
import { getCheckoutSetting } from 'sagas/api/checkout-setting';
import { putUpdateSetting } from 'sagas/api/settings';
import { initialize } from 'redux-form';
import { setSetting, fetchOutlets } from 'actions/setting/checkout';
import * as actNotif from 'actions/notifications';
import { getSettingsNew, updateSettings } from 'api/settings';
import isFeatureEnabled from 'selectors/isFeatureEnabled';
import { getOutlets } from 'api/outlets';
import {
  settingCheckoutStart as settingCheckoutStartClevertap,
  settingCheckoutSave as settingCheckoutSaveClevertap,
} from 'clevertap/settings/checkout';

export function* fillForm(data, enableTaxConfiguration) {
  // see CheckoutForm for formname
  const formName = 'checkout';
  const initialValues = {
    tax: data.enable_tax,
    gratuity: data.enable_gratuity,
    includeGratuityTax: data.include_gratuity_tax.toString(),
    trackServer: data.track_server,
    roundingOption: data.rounding_settings
      ? data.rounding_settings.rounding_id
      : data.rounding_settings_options[0].id,
    roundingDownBelow: data.rounding_settings
      ? data.rounding_settings.rounding_down_amount
      : 1,
    rounding: data.enable_rounding && data.rounding_settings != null,
    isStockLimit: data.is_stock_limit,
    isStockOverride: data.is_override_stock_limit,
  };

  if (enableTaxConfiguration) {
    yield put(
      initialize(formName, { outlets: data.outlets, ...initialValues })
    );
  } else {
    yield put(initialize(formName, initialValues));
  }
}

export function* pageRequestFlow() {
  try {
    const enableTaxConfiguration = yield select(
      isFeatureEnabled,
      'enable-tax-configuration'
    );

    let data = {};
    if (enableTaxConfiguration) {
      const {
        data: { setting },
      } = yield call(getSettingsNew);
      data = setting;
      const {
        data: { data: outlets },
      } = yield call(getOutlets, {
        active: 'all',
        size: 99999,
      });
      yield put(fetchOutlets(outlets));
    } else {
      data = yield call(getCheckoutSetting, {});
    }

    settingCheckoutStartClevertap(data);
    if (data) {
      yield call(fillForm, data, enableTaxConfiguration);
      yield put(setSetting(data));
    }
  } catch (e) {
    yield put(actNotif.error(e.message));
  }
}

export function* updateSettingFlow(req) {
  try {
    const enableTaxConfiguration = yield select(
      isFeatureEnabled,
      'enable-tax-configuration'
    );

    const { data } = req.payload;
    let res = {};

    if (enableTaxConfiguration) {
      const {
        data: { setting },
      } = yield call(updateSettings, data);
      res = setting;
    } else {
      res = yield call(putUpdateSetting, data);
    }

    if (res) {
      yield call(fillForm, res, enableTaxConfiguration);
      settingCheckoutSaveClevertap(res);
      if (enableTaxConfiguration) {
        // Message is not provided by new API
        yield put(actNotif.success('Setting has been successfully updated'));
        yield put(setSetting(res));
      } else {
        yield put(actNotif.success(res.message));
      }
    }
  } catch (e) {
    yield put(actNotif.error(e.message));
  }
}

export default function* settingCheckoutSaga() {
  yield takeEvery(SETTING_CHECKOUT_PAGE_REQUEST, pageRequestFlow);
  yield takeEvery(SETTING_CHECKOUT_UPDATE_SETTING, updateSettingFlow);
}
